exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table .table-row{border-bottom:1px solid #ededed}.table .table-row .table-row-column{padding:7.5px 15px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.table.hover .table-row:hover{background-color:#ededed}.table .sortable-column{cursor:pointer}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Table/TableRowColumn/style.scss
// module id = 6506
// module chunks = 0